/**
 * Утилиты форматирования для режима Rush Drop.
 */

/**
 * Формат таймера: "07:00" или "01:12:40" (с часами, если >= 1 ч).
 * Моноширинность цифр обеспечивается классом tabular-nums на элементе.
 */
export const formatClockTimer = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0))
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const secs = total % 60
  const mm = String(minutes).padStart(2, '0')
  const ss = String(secs).padStart(2, '0')
  if (hours > 0) {
    return `${String(hours).padStart(2, '0')}:${mm}:${ss}`
  }
  return `${mm}:${ss}`
}

/**
 * Время до недельного розыгрыша: ровно одна крупнейшая ненулевая единица,
 * как в бэкендовском title. Минуты округляются вверх и не опускаются до 0 —
 * «через 0 минут» читается как «уже прошло».
 * Единицы — короткие инвариантные сокращения (дн/ч/мин), плюрализация не нужна.
 */
export const formatDrawLeft = (seconds, t) => {
  const s = Math.max(0, Math.round(Number(seconds) || 0))
  if (s >= 86400) return t('rushdrop.weekly.days', { count: Math.floor(s / 86400) })
  if (s >= 3600) return t('rushdrop.weekly.hours', { count: Math.floor(s / 3600) })
  return t('rushdrop.weekly.minutes', { count: Math.max(1, Math.ceil(s / 60)) })
}

/**
 * Фонд эвента: сумма crystals × количество мест в каждом слоте призов.
 */
export const calcPrizeFund = (prizes = []) =>
  (Array.isArray(prizes) ? prizes : []).reduce((sum, prize) => {
    const from = Number(prize?.place_from || 0)
    const to = Number(prize?.place_to || 0)
    const places = Math.max(1, to - from + 1)
    return sum + Number(prize?.crystals || 0) * places
  }, 0)

/**
 * Русская плюрализация для подписей с числами.
 * pluralRu(1, 'балл', 'балла', 'баллов') → 'балл'
 */
export const pluralRu = (n, one, few, many) => {
  const value = Math.abs(Math.round(Number(n) || 0))
  const mod100 = value % 100
  const mod10 = value % 10
  if (mod100 >= 11 && mod100 <= 14) return many
  if (mod10 === 1) return one
  if (mod10 >= 2 && mod10 <= 4) return few
  return many
}
